import { render, staticRenderFns } from "./YfModal.vue?vue&type=template&id=534bb3d8&scoped=true&"
import script from "./YfModal.vue?vue&type=script&lang=js&"
export * from "./YfModal.vue?vue&type=script&lang=js&"
import style0 from "./YfModal.vue?vue&type=style&index=0&id=534bb3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534bb3d8",
  null
  
)

export default component.exports